import uiCore = require("../../core/uicore");
import entityCache = require("../../core/entitycache");
import entityHelper = require("../../core/entityhelper");

export class JobTitleDetails implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "personjobtitlesdetails",
        Url: "/jobtitles/{jobTitleId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Jobtitles",
        StateString: "resources.personsjobtitlesdetails",
        Template: require("./jobtitles.details.html"),
        AngularDependencies: [{ $angularInjectionId: "$mdDialog" }, { $angularInjectionId: "$state" }, { $angularInjectionId: "$stateParams" }, { $angularInjectionId: "$scope" }]
    }

    public jobtitle: Nema.Crew.Model.PersonJob;
    protected dataCache: entityCache.EntityCache;
    private $mdDialog: ng.material.IDialogService;
    private $state: ng.ui.IStateService;

    constructor($mdDialog, $state, $stateParams, $scope, ..._args: any[]) {
        var self = this;
        self.$mdDialog = $mdDialog;
        self.$state = $state;
        var jobTitleId = (<JobTitleStateParams><any>$stateParams).jobTitleId;
        self.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var scope = $scope;

        var dataDependencies: string[] = [
            entityCache.EntityTypeNames.Person,
            entityCache.EntityTypeNames.PersonJob,
            entityCache.EntityTypeNames.JobType,
        ];
        var entitiesPromise = self.dataCache.getEntitySetsPromise(dataDependencies);

        entitiesPromise.then(_res => {
            self.jobtitle = <any>self.dataCache.getEntity(entityCache.EntityTypeNames.PersonJob, jobTitleId);
            scope.$apply();
        });

    }


    public delete() {

        var listOfChanges = [
            () => { (<breeze.Entity><any>this.jobtitle).entityAspect.setDeleted(); }
        ];

        var person = this.jobtitle.Person;

        entityHelper
            .confirmedSaveSequentialListOfChangesAndNavigate(
            listOfChanges,
            "Delete Work Group",
            "Please confirm to delete Work Group",
            this.dataCache.entityManager,
            this.$mdDialog,
            () => { this.goToPersonPage(this.$state, person) },
            this.$state);
    }

    public edit() {
        this.$state.go("app.resources.personsjobtitlesedit", { jobTitleId: this.jobtitle.Id });
    }

    public goToPersonPage(state: ng.ui.IStateService, person: Nema.Crew.Model.Person) {
        state.go("app.resources.persons.detail", { personId: person.Id });
    }
}

export class JobTitleStateParams {
    jobTitleId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/jobtitles/jobtitles.details.ts